import easyfyAxios from '@shared/easyfy.axios';

export interface ICountryPopupApiRequest {
  country: string;
  site: string;
}

export const GetCountryPopupModal = async (data: ICountryPopupApiRequest): Promise<any> => {
  const queryString = new URLSearchParams({
    country: data.country,
    site: data.site,
  });

  return await easyfyAxios.get(`/api/countrypopup?${queryString.toString()}`);
};
